



























































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import WalletKey from "@/components/wallet-key";
import CyuricaWalletKey from "@/components/cyurica-wallet-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }
    const cyuricaWalletStore = inject(CyuricaWalletKey);
    if (!cyuricaWalletStore) {
      throw new Error(`${cyuricaWalletStore} is not provided`);
    }
    const globalStore = context.root.$store;
    const loading = computed(() => globalStore.auth.loading);
    const accessToken = computed(() => globalStore.auth.token);
    const walletList = computed(() => {
      let list = walletStore.walletList;
      list.forEach((wallet: any, index: number) => {
        if (wallet.company_code_item.internal_value === "0000095000") {
          list.splice(index, 1);
        }
      });
      return list;
    });
    const companyWallet = computed(() => cyuricaWalletStore.companyWallet);
    const amount = computed(() => cyuricaWalletStore.amount);
    const commission = computed(() => cyuricaWalletStore.commission);
    const response = computed(() => cyuricaWalletStore.response);
    const loadedFlag = ref<boolean>(false);

    const validateChargeActionFlag = ref<boolean>(false);
    const displayChargeErrorFlag = computed(
      () => cyuricaWalletStore.displayChargeErrorFlag
    );
    const displayChargeError = computed(
      () => cyuricaWalletStore.displayChargeError
    );

    // set
    const setCompanyWallet = (e: any) => {
      cyuricaWalletStore.setCompanyWallet(e);
      cyuricaWalletStore.validateChargeParams();
      cyuricaWalletStore.getCommission(companyWallet.value.companyCode);
      if (response.value.status >= 400) {
        displayuiStore.showErrorSnackBar("手数料取得でエラーが発生しました。");
      }
    };
    const setAmount = (e: any) => {
      cyuricaWalletStore.setAmount(e);
      cyuricaWalletStore.validateChargeParams();
    };

    const confirm = async () => {
      validateChargeActionFlag.value = true;
      cyuricaWalletStore.validateChargeParams();
      if (!displayChargeErrorFlag.value) {
        context.root.$router.push({ name: "MemberWalletChargeConfirm" });
      }
    };

    onMounted(async () => {
      loadedFlag.value = false;
      walletStore.setAuthorizationHeader(accessToken.value);
      cyuricaWalletStore.setAuthorizationHeader(accessToken.value);
      await walletStore.getWalletList();
      cyuricaWalletStore.clearCompanyWallet();
      cyuricaWalletStore.clearSelectedCompanyDispValue();
      cyuricaWalletStore.clearAmount();
      cyuricaWalletStore.clearCommission();
      cyuricaWalletStore.clearResponse();
      displayuiStore.clearErrorSnackBar;
      loadedFlag.value = true;
    });

    return {
      loading,
      loadedFlag,
      walletList,
      companyWallet,
      amount,
      commission,
      setCompanyWallet,
      setAmount,
      confirm,
      validateChargeActionFlag,
      displayChargeErrorFlag,
      displayChargeError
    };
  },
  components: {}
});
